import { useNavigate } from 'react-router-dom';

import { updateUserTraining } from 'api/Admin/Trainings/Trainings';

import { useCustomMutation } from 'lib/hooks/useCustomMutation';
import { formatDate, formatInTimeZone } from 'lib/helpers/dateUtils';

import Modal from 'components/shared/Modal/Modal';

import useEditTrainingFormik from '../lib/useEditTrainingFormik';

import EditTrainingForm from './EditTrainingForm';

const EditTrainingModal = ({
  training,
  isOpen,
  handleClose,
  practiceId,
  hardGoLiveDate,
  timezone
}) => {
  const navigate = useNavigate();

  const initialValues = {
    name: training?.name ?? '',
    meetingDate: training?.starts_at
      ? formatDate(training.starts_at, timezone, 'MM/dd/yyyy')
      : (training?.meeting_date ?? ''),
    startTime: training?.starts_at
      ? formatInTimeZone(new Date(training.starts_at), timezone, 'HH:mm')
      : (training?.start_time ?? ''),
    endTime: training?.ends_at
      ? formatInTimeZone(new Date(training.ends_at), timezone, 'HH:mm')
      : (training?.end_time ?? ''),
    meetingLink: training?.meeting_link ?? ''
  };

  const formik = useEditTrainingFormik(initialValues, async (values) => {
    const submissionValues = {
      ...values,
      meetingDate: values.meetingDate ? formatDate(values.meetingDate, null, 'yyyy-MM-dd') : null,
      startTime: values.startTime ? `${values.startTime}:00` : null,
      endTime: values.endTime ? `${values.endTime}:00` : null
    };
    await mutateTraining.mutateAsync(submissionValues);
  });

  const mutateTraining = useCustomMutation({
    mutationFn: (values) =>
      updateUserTraining(navigate, {
        ...values,
        practiceId,
        id: training?.id,
        isOptedIn: training?.is_opted_in ?? true
      }),
    invalidateQueryKey: ['user-trainings', 'wizard-instance'],
    successMessage: 'Training updated',
    onSuccess: () => {
      formik.resetForm();
      handleClose();
    }
  });

  return (
    <Modal
      slideFromRight
      isOpen={isOpen}
      handleClose={handleClose}
      title="Edit training"
      footerActions={{
        primary: {
          text: 'Save changes',
          onClick: () => formik.handleSubmit(),
          isLoading: mutateTraining.isLoading
        }
      }}>
      <EditTrainingForm formik={formik} hardGoLiveDate={hardGoLiveDate} />
    </Modal>
  );
};

export default EditTrainingModal;
